import { Injectable } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { EMPTY } from 'rxjs'
import { map, mergeMap, catchError } from 'rxjs/operators'
import { AuthService } from '@appService/auth.service'

@Injectable()
export class UserRulesEffects {

  pullRules$ = createEffect(() =>
    this.actions$.pipe(
      ofType('[UserRules] Pull'),
      mergeMap(() => this.authService.getUserRolesAll()
        .pipe(
          map(resp => {
            return { type: '[UserRules] Replace', payload: { rules: resp?.data } }
          }),
          catchError(() => EMPTY)
        )
      )
    )
  )

  constructor(
    private actions$: Actions,
    private authService: AuthService
  ) {
  }
}
